// frontend/src/components/ai/QuickTopics.tsx

import { useState } from 'react';

interface TopicItem {
  id: string;
  title: string;
  subtitle: string;
  prompt: string;
}

interface TopicCategory {
  id: string;
  name: string;
  icon: string;
  topics: TopicItem[];
}

const CATEGORIES: TopicCategory[] = [
  {
    id: 'math',
    name: 'Matematik & Mantık',
    icon: '📐',
    topics: [
      { id: 'fractions', title: 'Kesirler & Oranlar', subtitle: 'Matematik Temelleri', prompt: 'Kesirler konusunu günlük hayattan eğlenceli örneklerle anlatır mısın?' },
      { id: 'geometry', title: 'Geometrik Şekiller', subtitle: 'Alan ve Çevre', prompt: 'Üçgen, kare ve dairenin alan formüllerini basitçe açıkla.' },
      { id: 'logic', title: 'Mantık Bulmacaları', subtitle: 'Zeka Oyunları', prompt: 'Bana çözmem için eğlenceli bir matematiksel mantık sorusu sor.' },
    ],
  },
  {
    id: 'coding',
    name: 'Kodlama & Algoritma',
    icon: '🐍',
    topics: [
      { id: 'variables', title: 'Değişkenler', subtitle: 'Veri Saklama', prompt: 'Değişken nedir, neden kullanılır? Pratik bir örnekle anlat.' },
      { id: 'loops', title: 'Döngüler (Loops)', subtitle: 'Tekrarlayan İşler', prompt: 'For ve While döngüleri nasıl çalışır, mantığını anlat.' },
      { id: 'functions', title: 'Fonksiyonlar', subtitle: 'Kod Blokları', prompt: 'Fonksiyonların mantığı nedir, basit bir örnek kod ver.' },
    ],
  },
  {
    id: 'science',
    name: 'Fen & Teknoloji',
    icon: '🧪',
    topics: [
      { id: 'photosynthesis', title: 'Fotosentez', subtitle: 'Bitki Biyolojisi', prompt: 'Bitkiler nasıl fotosentez yapar, güneş ışığının rolü nedir?' },
      { id: 'solar_system', title: 'Güneş Sistemi', subtitle: 'Uzay & Gezegenler', prompt: 'Güneş sistemimizdeki gezegenleri sırasıyla ve eğlenceli bilgilerle tanıt.' },
      { id: 'ai_basics', title: 'Yapay Zeka Nasıl Çalışır?', subtitle: 'Geleceğin Teknolojisi', prompt: 'Yapay zeka (AI) insan gibi nasıl düşünüyor, mantığı nedir?' },
    ],
  },
  {
    id: 'languages',
    name: 'Türkçe & İngilizce',
    icon: '📚',
    topics: [
      { id: 'english_daily', title: 'İngilizce Pratik', subtitle: 'Daily Conversation', prompt: 'Bana günlük hayatta en çok kullanılan 10 İngilizce cümleyi Türkçe anlamlarıyla öğret.' },
      { id: 'reading_comp', title: 'Paragrafta Ana Fikir', subtitle: 'Okuma Anlama', prompt: 'Bir metnin ana fikri ve yardımcı fikirleri nasıl bulunur?' },
    ],
  },
];

interface QuickTopicsProps {
  onSelectTopic: (prompt: string) => void;
}

export function QuickTopics({ onSelectTopic }: QuickTopicsProps) {
  const [activeCategory, setActiveCategory] = useState<string>('math');

  const category = CATEGORIES.find((c) => c.id === activeCategory) || CATEGORIES[0];

  return (
    <div className="ai-mentor-topics-wrap">
      <div className="ai-mentor-category-tabs">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.id}
            type="button"
            className={`ai-mentor-cat-tab ${activeCategory === cat.id ? 'active' : ''}`}
            onClick={() => setActiveCategory(cat.id)}
          >
            <span>{cat.icon}</span> {cat.name}
          </button>
        ))}
      </div>

      <div className="ai-mentor-topics" role="list" aria-label="Hızlı konular">
        {category.topics.map((t) => (
          <button
            key={t.id}
            type="button"
            role="listitem"
            className="ai-mentor-topic-item current"
            onClick={() => onSelectTopic(t.prompt)}
          >
            <span className="ai-mentor-topic-icon current">{category.icon}</span>
            <span className="ai-mentor-topic-info">
              <strong>{t.title}</strong>
              <span>{t.subtitle}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
